module.exports = __webpack_public_path__ + "static/4-e1acac0fb405c2f15c8c595331c86071.jpg";